import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import Animate, { AnimationTypes } from "../Animate/Animate"

interface MessageListProps {
  message: string
  icon: IconProp
  color?: string
  iconColor?: string
  animationTypes?: keyof typeof AnimationTypes
  animationDuration?: string
}

export const MessageList: React.FC<MessageListProps> = ({
  iconColor,
  color,
  message,
  icon,
  animationDuration = "1s",
  animationTypes = AnimationTypes.fadeInTraslate,
}) => {
  return (
    <Animate type={animationTypes} duration={animationDuration}>
      <div
        className="
          w-full
          flex
          items-center
          justify-start
          gap-3
          rounded-md
          p-2.5
        "
        style={{ backgroundColor: color }}
      >
        <FontAwesomeIcon icon={icon} color={iconColor ?? "#dc2626"} />

        <span
          className="
            text-[0.8rem]
            font-bold
            italic
            text-neutral-800
            text-center
          "
        >
          {message}
        </span>
      </div>
    </Animate>
  )
}
